import endpoints from '@/utils/constants';
import { apiHelper } from '@/utils/helpers';
const actions = {
    getLaborCosts(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.laborCosts}`).then((res) => {
                if (res.status === 200) {
                    context.commit('setLaborCostList', res.data)
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    //save cost
    saveLaborCost(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post', `${endpoints.BASE_URL}${endpoints.API.laborCosts}`, context.state.labor).then((res) => {
                if (res.status === 201) {
                    resolve(res);
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    //update cost
    updateLaborCost(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.laborCosts}/${context.state.labor.laborCostId}`, context.state.labor).then((res) => {
                if (res.status === 200) {
                    context.commit('setlaborCost', res.data);
                    resolve(res.data);
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    //edit labor cost
    fetchlaborCost(context, laborCostId) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.laborCosts}/${laborCostId}`).then((res) => {
                if (res.status === 201) {
                    context.commit('setlaborCost', res.data);
                    resolve(res.data);
                }
            }).catch(err => {
                reject(err);
            })
        })
    }
}

export default actions;